import type Transaction from "@/classes/Transaction.ts";
import type { DateRange } from "@/types/date";

import { isOn } from "@/libs/features.ts";

export default class TransactionRequest {
  tx: {
    amount: number;
    applyToIncomeTax?: boolean;
    currency: "EUR" | "USD";
    date: string;
    description: string;
    isDisabled: boolean;
    group: number | null;
    ledger: number;
    name: string;
    recurrence: string | null;
    settlesReservation?: string | null;
    tax: null;
  };
  dateRange: DateRange;

  constructor(tx: Transaction, dateRange: DateRange) {
    this.tx = {
      amount: tx.amount,
      currency: tx.currency,
      // A transaction date is a calendar day, but a Dayjs serializes to an ISO instant: local
      // midnight in CET/CEST becomes 22:00Z the day before. Send the day itself.
      date: tx.date.format("YYYY-MM-DD"),
      description: tx.description,
      isDisabled: tx.isDisabled,
      group: tx.group?.id ?? null,
      ledger: tx.ledger!.id,
      name: tx.name,
      recurrence: tx.recurrence?.toString() ?? null,
      tax: null,
    };

    if (isOn("income-tax")) {
      this.tx.applyToIncomeTax = tx.applyToIncomeTax && !tx.settlesReservation;
      this.tx.settlesReservation = tx.settlesReservation;
    }

    this.dateRange = dateRange;
  }
}
